module.exports = __webpack_public_path__ + "img/fortress64_ua.8f0565c0.webp";